import React, { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Typography, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { PreviewAddress } from "pagesV2/pro/Experiences/ListingPreview/PreviewAddress"
import { PreviewMediaListing } from "pagesV2/pro/Experiences/ListingPreview/PreviewMedia"
import PreviewAbout from "pagesV2/pro/Experiences/ListingPreview/PreviewAbout"
import { PreviewMeetingLocation } from "pagesV2/pro/Experiences/ListingPreview/PreviewMeetingLocation"
import { PreviewGuide } from "pagesV2/pro/Experiences/ListingPreview/PreviewGuide"
import EmbeddedBookingLayout from "../EmbeddedBookingLayout"
import { PageName } from "ui/PageName"
import { routes } from "router"
import BookingDetailCard from "../ExperienceBooking/BookingDetailCard"
import { fetchExperienceById } from "store/experiences"
import styles from "../ExperienceListing/ExperienceListing.module.css"
import PropTypes from "prop-types"
import EmbeddedPageHeader from "../EmbeddedPageHeader"
import { useTheme } from "context/AntdThemeContext"

const { Title } =  Typography

const EmbeddedExperienceDetail = ({ mode }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [t] = useTranslation()
  const { uuid, id } = useParams()
  const b_uuid = location.state?.b_uuid
  const { loading, experienceDetail } = useSelector((state) => state?.experiences?.experienceById)
  const { switchTheme } = useTheme()
  const [bookingErrors, setBookingErrors] = useState({
    date: false,
    counts: false,
    tripLength: false,
    timeSlot: false
  })

  useEffect(() => {
    if (id) {
      dispatch(fetchExperienceById(id, b_uuid, mode))
    }
  }, [id, dispatch, b_uuid, mode])

  // Apply theme based on guide's adventure_mode
  useEffect(() => {
    if (experienceDetail?.guide?.adventure_mode) {
      switchTheme(experienceDetail.guide.adventure_mode)
    }
  }, [experienceDetail?.guide?.adventure_mode, switchTheme])

  return (
    <>
      {!mode && <EmbeddedPageHeader />}
      {loading && (
        <div className={styles.loaderOverlay}>
          <Spin size="large" />
        </div>
      )}
      <EmbeddedBookingLayout type={"experience_detail"}>
        {!mode && <PageName title={"Experience Details"} backPath={routes.embeddedExperienceListing({ uuid: uuid })} type={"embedded"} />}
        <div style={{ position: "relative", paddingRight: "100px", marginTop: "40px" }}>
          <Title level={2} className={styles.experienceTitle}>
            {experienceDetail?.title}
          </Title>
        </div>
        <PreviewAddress trip={experienceDetail} t={t} />
        <PreviewMediaListing trip={experienceDetail} />
        <Row gutter={[50, 10]}>
          <Col span={24} lg={16} className="mb-l">
            <PreviewAbout trip={experienceDetail} t={t} />
            <PreviewMeetingLocation trip={experienceDetail} t={t} />
            <PreviewGuide trip={experienceDetail} t={t} mode={"embedded"} />
          </Col>
          <Col span={24} lg={8} style={{ paddingTop: "40px" }}>
            <BookingDetailCard
              bookNow={true}
              trip={experienceDetail}
              bookingButtonVisible={true}
              bookingErrors={bookingErrors}
              setBookingErrors={setBookingErrors}
              mode={mode}
            />
          </Col>
        </Row>
      </EmbeddedBookingLayout>
    </>
  )
}

EmbeddedExperienceDetail.propTypes = {
  mode: PropTypes.string
}

export default React.memo(EmbeddedExperienceDetail)
